























import { Component, Vue } from "vue-property-decorator";
import AppHeaderBar from "@/components/organisms/AppHeaderBar.vue";
import VrSpaceContents from "@/components/templates/VrSpaceContents.vue";
import VrTagContents from "@/components/templates/VrTagContents.vue";
import { MattertagParams } from "@/interfaces/ContentsParams";
import {VueEventTypes} from "@/events/AppEvent";


@Component({
  components: {
    VrTagContents,
    VrSpaceContents,
    AppHeaderBar
  }
})
export default class AnrealageVR extends Vue {

  // アプリケーションヘッダー
  public headerBar: AppHeaderBar;

  /* フラグ変数 */
  // タグコンテンツエリアを表示するかのフラグ
  private isShownTagContents: boolean = false;
  // タグコンテンツ
  private selectTagContents: MattertagParams = null;


  /* Lifecycle Hook */
  mounted (): void {
    this.$nextTick(() => {
      this.headerBar = <AppHeaderBar> this.$refs.headerBar;
    });
  }

  private onVrSpaceLoaded (): void {
    console.log('VR Space Loaded');
    this.$eventHub.$emit(VueEventTypes.APP_LOAD_COMPLETE);
  }

  /**
   * VR空間でMattertagがクリックさせれた時のイベントハンドラ
   * @param tagParam
   */
  private onClickMattertag (tagParam: MattertagParams): void {
    console.log('[Click Tag Event: ' + tagParam.label + '] ', tagParam);
    this.selectTagContents = tagParam;
    this.isShownTagContents = true;
  }

  /**
   * タグコンテンツを閉じた時に呼び出されるイベントハンドラ
   */
  private onCloseTagContents (): void {
    // タグコンテンツエリアの表示を非表示にする
    this.isShownTagContents = false;
    this.isShownTagContents = null;
  }

}
